import { LitElement, TemplateResult, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import innerStyles from '../outline-accent-bar/styles/outline-accent-bar.inner.pcss?inline';
import { ResizeController } from '../../controllers/resize-controller';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import '../outline-container/outline-container';

/**
 * The OutlineAccentBar component
 * @element outline-accent-bar
 */
@customElement('outline-accent-bar')
export class OutlineAccentBar extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    encapsulatedCSS: innerStyles,
  });
  resizeController: ResizeController = new ResizeController(this, {
    breakpoints: [1024],
  });

  @property({ type: Boolean, reflect: true })
  isMobile: boolean;

  @property({ type: String, reflect: true })
  context: string = '';

  updated() {
    this.isMobile = this.resizeController.currentBreakpointRange === 0;
  }

  render(): TemplateResult {
    const bgColor =
      this.context === 'homepage-hero'
        ? 'brand-boldest'
        : 'brand-primary';

    const containerStyle =
      this.context === 'homepage-hero' ? 'position: relative; z-index: 4;' : '';

    return html`
      <outline-container
        content-max-width=${this.isMobile ? 'full-bleed' : 'default'}
        background-color=${bgColor}
        x-padding="space-0"
        y-padding="space-0"
        style=${containerStyle}
      >
        <div class="outline-accent-bar--wrapper">
          <span class="outline-accent-bar--lightest"></span>
          <span class="outline-accent-bar--lighter"></span>
          <span class="outline-accent-bar--light"></span>
        </div>
      </outline-container>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'outline-accent-bar': OutlineAccentBar;
  }
}
